export default __webpack_public_path__ + "static/media/templateClose.1ffe9a3c.svg";